<template>
  <div class="page">
    <div class="main" id="staking_content_2">
      <div class="info" :style="{ paddingTop: 35 + statusBarHeight + 'px' }">
        <div class="bg"></div>
        <div class="header" :style="{ top: 35 + statusBarHeight + 'px' }">
          <div class="back" @click="handleClose"></div>
          <div class="title">Staking NFT</div>
        </div>
        <div class="info-list">
          <div class="token">#{{ token_id }}</div>
          <div class="level">Lv.{{ level }}</div>
          <img
            class="quality"
            :src="
              require(`@/assets/images/YuliApp/common/Yuli/type/${type_name}.png`)
            "
            v-if="type_name"
          />
          <img
            class="type"
            :src="
              require(`@/assets/images/YuliApp/common/Yuli/property/icon_${quality_name}.png`)
            "
            v-if="quality_name"
          />
        </div>
        <img class="icon" :src="img_url" v-if="img_url" />

        <div class="staking-plan">
          <div class="staking-plan-text-list">
            <div class="staking-plan-text-item">
              <span class="nums">{{ passcardPlan }}</span>
              Passcard/{{ stackingPlan }}
            </div>
          </div>
          <div class="staking-plan-text-list">
            <div class="staking-plan-text-item">
              <span class="nums">{{ tofixUtil(artPlan, 2) }}</span
              >ART/Day
            </div>
            <div class="staking-plan-text-item">
              <span class="nums">{{ expPlan }}</span
              >EXP/Day
            </div>
          </div>
        </div>
      </div>

      <div class="reward">
        <div :class="['title', 'title-reward']">Staking Rewards</div>

        <div class="reward-list">
          <div class="reward-item">
            <div class="reward-item-title">CONSUMPTION</div>
            <div class="benefit-list">
              <!-- ARG  -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_arg.png')
                  "
                />
                <div class="benefit-item-text">
                  {{ costArg ? costArg.toLocaleString("en") : 0 }}
                </div>
              </div>
              <!-- 折扣券 -->
              <div
                :class="['benefit-item', 'benefit-item-discount']"
                v-if="costDiscount != 0"
              >
                <div class="benefit-item-icon">
                  <!-- styles_common[`yuli-discount-${quality}`] -->
                  <div class="benefit-item-icon-discount"></div>
                </div>
                <div class="benefit-item-text">
                  {{ costDiscount }}
                </div>
              </div>
            </div>
          </div>

          <div class="reward-item">
            <div class="reward-item-title">Have Earned by Staking</div>

            <div class="benefit-list">
              <!-- Passcard -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_passcard.png')
                  "
                />
                <div class="benefit-item-text">
                  {{ !isConsum && isRedeem ? 0 : passcard }}
                </div>
              </div>
              <!-- ART -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_art.png')
                  "
                />
                <div class="benefit-item-text">
                  {{
                    !isConsum && isRedeem ? 0 : art == 0 ? 0 : tofixUtil(art, 2)
                  }}
                </div>
              </div>
              <!-- EXP -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_exp.png')
                  "
                />
                <div class="benefit-item-text">
                  {{ !isConsum && isRedeem ? 0 : exp }}
                </div>
              </div>
            </div>

            <!-- <div
            class="benefit-list"
            style="{{marginTop: '8px'}}"
            v-if="isCanClaimPasscard && isStakingOver"
          >
            <div class="benefit-item">
              <img
                class="benefit-item-icon"
                :src="
                  require('@/assets/images/YuliApp/YuliStaking/icon_passcard.png')
                "
              />
              <div class="benefit-item-text">
                {{ !isConsum ? 0 : passcard }}
              </div>
              <div
                :class="[
                  'benefit-item-btn',
                  isClaimedPasscard && 'benefit-item-btnClaimed',
                ]"
                @Click="handlePasscardClaimClick"
              >
                <div v-if="isClaimedPasscard">
                  <img
                    class="benefit-item-btnClaimed-icon"
                    :src="
                      require('@/assets/images/YuliApp/YuliStaking/icon_yes.png')
                    "
                  />
                  <span>Claimed</span>
                </div>

                <div v-if="!isClaimedPasscard">
                  <div class="btn-loading" v-if="isClaiming"></div>

                  <div v-if="!isClaiming">
                    <span>{{ "Claim >" }}</span>
                    <div class="benefit-item-btn-dot"></div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          </div>

          <!--  v-if="!(isCanClaimPasscard && isStakingOver)" -->
          <div class="reward-item">
            <div class="reward-item-title">Total Expected Rewards</div>
            <div class="benefit-list">
              <!-- Passcard -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_passcard.png')
                  "
                />
                <div class="benefit-item-text">
                  {{ passcardTotal }}
                </div>
              </div>
              <!-- ART -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_art.png')
                  "
                />
                <div class="benefit-item-text">
                  {{ artTotal == 0 ? 0 : tofixUtil(artTotal, 2) }}
                </div>
              </div>
              <!-- EXP -->
              <div class="benefit-item">
                <img
                  class="benefit-item-icon"
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_exp.png')
                  "
                />
                <div class="benefit-item-text">
                  {{ expTotal }}
                </div>
              </div>
            </div>
          </div>

          <div class="reward-item">
            <div class="reward-item-title">Staking Plan</div>
            <div class="plan">
              <div class="plan-text">{{ stackingPlan }}</div>
            </div>
          </div>

          <div class="reward-item">
            <div class="reward-item-title">Staking Ends at</div>
            <div class="countdown">
              <div class="countdown-over-wrap" v-if="isStakingOver">
                <div class="countdown-over">Already Ended</div>
              </div>

              <div class="countdown-item" v-if="!isStakingOver">
                <CountDown
                  :size="'detail'"
                  :end_at="end_at"
                  @onCountDownEnd="handleCountDownEnd"
                  @onDayChange="handleComputeIncome"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="buttonView" v-if="isStakingOver && !isRedeem">
          <div :class="['redeem', 'btn']" @click="handleToRedeem">
            <div
              :class="['btn-loading', 'btn-loading-black']"
              v-if="isRedeemingRef && redeemingToken == token_id"
            ></div>
            <div v-else>Redeem Yuli</div>
          </div>
          <!-- <div :class="['renewal', 'btn']" @click="handleToRenewal">
            Continue Staking
          </div> -->

          <!-- <div class="tips-text">
            Whether redeem or continue, you will obtain your ART and EXP rewards
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import appBridging from "@/utils/appBridging.js";
import store from "@/store";
import { getYOG2StakingRecord, getYuliList } from "@/api/staking.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import {
  PASSCARD_INCOME_MAP,
  ART_INCOME_MAP,
  YULI_QUALITY_TYPE_MAP,
  getPasscardIncomByDay,
  ARG_COST_MAP,
} from "@/components/YuliStaking/constants/incomeMap.js";
import { getDiffDays } from "@/utils/date.js";
import { floatMul } from "@/utils/math.js";
import { tofix } from "@/utils/utils";
import {
  YULI_ROLE_TYPE_MAP,
  YULI_ROLE_PROPERTY_TYPE_MAP,
  TIME_TYPE,
  TIME_TYPE_GROUP,
} from "@/components/YuliStaking/constants/type.js";
import CountDown from "../CountDown";

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    isRedeeming: {
      type: Boolean,
      default: false,
    },
    isClaiming: {
      type: Boolean,
      default: false,
    },
    redeemingToken: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CountDown,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler(value) {
        this.yuliData = value;
        this.handleInit(value);
      },
      immediate: true,
      deep: true,
    },
    isRedeeming: {
      handler(value) {
        this.isRedeemingRef = value;
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const yuliData = ref(null);

    const img_url = ref("");
    const token_id = ref("");
    const level = ref(0);
    const quality = ref("");
    const quality_name = ref("");
    const type = ref("");
    const type_name = ref("");

    const passcard = ref(0);
    const art = ref(0);
    const exp = ref(0);

    const passcardTotal = ref(0);
    const artTotal = ref(0);
    const expTotal = ref(0);

    const stackingPlan = ref("");
    const passcardPlan = ref(0);
    const artPlan = ref(0);
    const expPlan = ref(375);

    const costArg = ref(0);
    const costArgNeed = ref(0);
    const costDiscount = ref(1);
    const costDiscountDot = ref(1);

    const end_at = ref(0);
    const isStakingOver = ref(false);
    const isCanClaimPasscard = ref(true); //是否可领取passcard
    const isClaimedPasscard = ref(false); //是否领取了passcard

    // 是否赎回
    const isRedeem = ref(false);

    // 是否付款
    const isConsum = ref(false);

    const tofixUtil = ref(tofix);

    const isRedeemingRef = ref(false);

    /**
     * 处理赎回
     */
    const handleToRedeem = () => {
      // if (!isConsum.value) {
      //   emit("onConsumComfrim");
      //   return;
      // }

      emit("onRedeem", yuliData.value);
    };

    /**
     * 处理续订
     */
    const handleToRenewal = () => {
      // if (!isConsum.value) {
      //   emit("onConsumComfrim");
      //   return;
      // }

      emit("onRenewal", yuliData.value);
    };

    /**
     * 处理倒计时结束
     */
    const handleCountDownEnd = () => {
      isStakingOver.value = true;
      handleComputeIncome();
      emit("onCountDownEnd");
    };

    /**
     * 处理数据
     */
    const handleInit = (data) => {
      const _image = data?.image;
      const extension_attribute = data?.extension_attribute;
      const _token_id = data?.token_id || extension_attribute?.token_id;

      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";
      const role_property = extension_attribute?.role_property;
      const role_property_name = YULI_ROLE_TYPE_MAP[role_property] || "";

      const extension = data?.extension;
      const _level = extension?.level;
      const days = extension?.days || 0;
      const start_time = extension?.start_time || 0;
      const end_time = extension?.end_time || 0;
      const redeem_at = extension?.redeem_at || "";

      // 计划
      const _art_income_map = ART_INCOME_MAP[role_type_name] || {};
      const _artPlan = _art_income_map[_level] || 0; // 天为单位

      const _passcard_income_map = PASSCARD_INCOME_MAP[role_type_name] || {};
      const _passcardPlan = _passcard_income_map[days] || 0;

      const _expPlan = 375; // 默认375每天

      const plan = days || 0;
      const _plan_group = TIME_TYPE_GROUP.find((item) => {
        return item?.key === plan;
      });
      const plan_label = _plan_group?.label || "";

      // 收益
      handleComputeIncome();

      // 总收益
      const _passcardTotal = _passcard_income_map[days] || 0;
      const _artTotal = floatMul(_artPlan, days);
      const _expTotal = floatMul(_expPlan, days);

      // 倒计时情况
      const _end_at = end_time * 1000;
      const nowaday = new Date().getTime();
      const _isStakingOver = nowaday > _end_at;

      // 赎回情况
      const is_redeem = data?.is_redeem || false;
      const _isRedeem = redeem_at || is_redeem;

      // 消耗情况
      const arg = Number(extension?.arg || "0");
      const cost_arg = Number(extension?.cost_arg || "0");
      const _arg_cost_map = ARG_COST_MAP[role_type_name] || {};
      const need_cost_arg = arg || _arg_cost_map[days] || 0;
      const _isConsum = Number(cost_arg) > 0;
      let isDiscount = _isConsum && Number(cost_arg) < Number(need_cost_arg);
      const _discount = isDiscount ? 1 : 0;
      // todo 预埋获取折扣道具折数
      // if (isConsum) {
      //   const dot = floatDiv(cost_arg, need_cost_arg);
      //   const _discount_dot = dot;
      //   setDiscountDot(_discount_dot);
      // }

      // passcard领取情况
      // const _isCanClaimPasscard = extension?.passcard > 0;
      const _isCanClaimPasscard = true;
      const _isClaimedPasscard = !(
        extension?.passcard_at == 0 && extension?.passcard_tx_hash == ""
      );

      isConsum.value = _isConsum;
      costArgNeed.value = need_cost_arg;
      costArg.value = cost_arg;
      costDiscount.value = _discount;

      img_url.value = _image;
      token_id.value = _token_id;
      level.value = _level;
      quality.value = role_property;
      quality_name.value = role_property_name;
      type.value = role_type;
      type_name.value = role_type_name;

      passcardTotal.value = _passcardTotal;
      artTotal.value = _artTotal;
      expTotal.value = _expTotal;

      stackingPlan.value = plan_label;
      artPlan.value = _artPlan;
      passcardPlan.value = _passcardPlan;
      expPlan.value = _expPlan;

      end_at.value = _end_at;
      isStakingOver.value = _isStakingOver;
      isRedeem.value = _isRedeem;

      isCanClaimPasscard.value = _isCanClaimPasscard;
      isClaimedPasscard.value = _isClaimedPasscard;
    };

    /**
     * 处理收益
     */
    const handleComputeIncome = () => {
      const extension_attribute = yuliData.value?.extension_attribute;
      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";

      const extension = yuliData.value?.extension;
      const level = extension?.level;
      const start_time = extension?.start_time || 0;
      const end_time = extension?.end_time || 0;
      const days = extension?.days || 0;

      // 计划收益
      const _art_income_map = ART_INCOME_MAP[role_type_name] || {};
      const _artPlan = _art_income_map[level] || 0; // 天为单位

      const _passcard_income_map = PASSCARD_INCOME_MAP[role_type_name] || {};
      const passcardPlan = _passcard_income_map[days] || 0;

      const _expPlan = 375; // 默认375每天

      const _end_at = end_time * 1000;
      const start_at = start_time * 1000;
      const nowaday = new Date().getTime();
      const _end_time = nowaday >= _end_at ? _end_at : nowaday;

      let _diff_days = getDiffDays(start_at, _end_time);
      // 服务数值返回不对的情况
      if (nowaday >= _end_at && !_diff_days) {
        _diff_days = days;
      }
      const _passcard = getPasscardIncomByDay(role_type_name, days, _diff_days);
      const _art = floatMul(_artPlan, _diff_days);
      const _exp = floatMul(_expPlan, _diff_days);

      passcard.value = _passcard;
      art.value = _art;
      exp.value = _exp;
    };

    const handlePasscardClaimClick = () => {
      emit("onClaimPasscard", { ...yuliData.value, isConsum: isConsum });
    };

    /**
     * 跳转关闭
     */
    const handleClose = () => {
      emit("onClose");
    };

    return {
      localesPackage,
      localesEnv,
      img_url,
      token_id,
      level,
      quality,
      quality_name,
      type,
      type_name,
      passcard,
      art,
      exp,
      passcardTotal,
      artTotal,
      expTotal,
      stackingPlan,
      passcardPlan,
      artPlan,
      expPlan,
      costArg,
      costArgNeed,
      costDiscount,
      costDiscountDot,
      end_at,
      isStakingOver,
      isCanClaimPasscard,
      isClaimedPasscard,
      isRedeem,
      isConsum,
      handleToRedeem,
      handleToRenewal,
      handleCountDownEnd,
      handleInit,
      handleComputeIncome,
      handleClose,
      yuliData,
      tofixUtil,
      handlePasscardClaimClick,
      isRedeemingRef,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
  background-color: #0f193b;

  .main {
    position: relative;
    flex: 1;
    width: 100%;
    overflow-y: auto;
  }

  .info {
    width: 355px;
    background-color: #19618a;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 452px;
    min-height: 410px;

    .bg {
      width: 100%;
      height: 452px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/bg.png");
      position: absolute;
      top: 0px;
      z-index: 0;
    }

    .header {
      width: 100%;
      height: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: fixed;
      z-index: 999;
    }

    .back {
      width: 81px;
      height: 26px;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/icon_back.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;
    }

    .title {
      color: #ffffff;
      font-family: "Tomorrow";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 19.2px;
      text-transform: uppercase;
      z-index: 1;
      margin-right: 15px;

      &-reward {
        // top: 30px;
        margin-right: 0px;
      }
    }

    .info-list {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      z-index: 1;
      margin-top: 60px;
    }

    .icon {
      z-index: 1;
      width: 230px;
      height: 230px;
      margin-top: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .token,
    .level {
      color: #aae1ff;
      font-family: "Inter";
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: #aae1ff;
      font-family: "Inter";
      font-size: 16px;
      font-style: normal;
    }

    .token {
      margin-right: 20px;
    }

    .level {
    }

    .quality,
    .type {
      width: 24px;
      height: 24px;
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .quality {
      margin-left: 96px;
      margin-right: 6px;
    }

    .type {
      margin-right: 40px;
    }

    .staking-plan {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 1;
      margin-top: 16px;

      &-text-list {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-bottom: 7.5px;
      }

      &-text-item {
        color: #aae1ff;
        font-family: "Inter";
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-right: 11px;

        .nums {
          color: #ffffff;
          font-family: "Inter";
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-right: 4px;
        }
      }
    }
  }

  .reward {
    // flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    @Left: 57px;
    @Width: 365px;
    flex: initial;
    background-image: linear-gradient(180deg, #12416c 0%, #1e779f 100%);
    margin-top: 2px;
    padding-bottom: 60px;

    .title {
      color: #ffffff;
      font-family: "Tomorrow";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 19.2px;
      text-transform: uppercase;
      z-index: 1;
      margin-right: 15px;

      &-reward {
        margin-right: 0px;
        margin-top: 20px;
      }
    }

    &-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 13px;
    }

    &-item {
      margin-bottom: 14px;

      &-title {
        color: #aae1ff;
        font-family: "Tomorrow";
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 14.4px;
        text-transform: uppercase;
        margin-bottom: 8px;
        margin-top: 6px;
        text-align: left;
      }

      .benefit-list {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 325px;

        .benefit-item {
          flex: 1;
          width: 107px;
          height: 40px;
          border-radius: 1px;
          background: #2f87ad33;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-right: 2px;
          max-width: 100%;

          &:last-child {
            margin-right: 0px;
          }

          &-icon {
            width: 24px;
            height: 24px;
            img {
              width: 100%;
              height: 100%;
            }

            &-discount {
              width: 100%;
              height: 100%;
              background-size: 100% 100%;
              background-position: center;
              background-repeat: no-repeat;
              background-image: url("~@/assets/images/YuliApp/YuliStaking/prop/white_staking_discount_coupon.png");
            }
          }

          &-text {
            color: #ffffff;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 18px;
            margin-left: 2px;
          }

          &-discount {
            max-width: 107px;
          }

          &-btn {
            margin-left: 28px;
            width: 78px;
            height: 22px;
            border-radius: 29px;
            border: 1px solid #7be8ff;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #00ffe0;
            font-family: "Inter";
            font-size: 13px;
            font-style: normal;
            font-weight: 800;
            line-height: normal;
            position: relative;

            .btn-loading {
              width: 20px;
              height: 20px;
            }

            &-dot {
              position: absolute;
              right: 2px;
              top: -8px;
              width: 16px;
              height: 16px;
              background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/icon_dot.png");
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
          }

          &-btnClaimed {
            cursor: unset;
            color: #2de31e;
            font-weight: 600;
            border: 1px solid #2de31e80;

            &-icon {
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }
          }
        }
      }

      .plan {
        width: 325px;
        height: 36px;
        border-radius: 1px;
        background: #2f87ad33;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &-text {
          color: #ffffff;
          font-family: "Inter";
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }

      .countdown {
        width: @Width;
        width: 325px;

        &-item {
          margin-top: 28px;
        }

        &-over {
          color: #ffa7a7;
          text-align: center;
          font-family: "Inter";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;

          &-wrap {
            margin-top: 20px;
            width: 100%;
            height: 46px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: #2f87ad33;
          }
        }
      }
    }

    .link-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: @Width;
      bottom: 47px;
      left: 0px;
      right: 0;
      width: initial;
      bottom: 38px;

      .link-item {
        color: #aae1ff;
        text-align: center;
        font-family: "Inter";
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        margin-bottom: 14px;

        &-url {
          color: #00ffe0;
          font-weight: 500;
          margin-left: 6px;
        }
      }

      &-redeem {
        bottom: 100px;
      }
    }

    .buttonView {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0f193b;
      text-align: center;
      font-family: "Tomorrow";
      font-size: 16px;
      font-weight: 500;
      line-height: 37.5px;
      flex-direction: column;
      margin-top: 60px;

      .redeem {
        width: 130px;
        height: 40px;
        min-height: 40px;
        background-image: url("~@/assets/images/YuliApp/YuliStaking/btn_white_bg.png");
        width: 200px;
        margin-bottom: 10px;
      }

      .renewal {
        width: 200px;
        height: 40px;
        min-height: 40px;
        background-image: url("~@/assets/images/YuliApp/YuliStaking/btn_bg.png");
      }

      .btn {
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .tips-text {
        margin-top: 16px;
        width: 284px;
        color: #aae1ff;
        text-align: center;
        font-family: "Inter";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
      }
    }

    .btn-loading {
      width: 28px;
      height: 28px;
      padding-top: 0px;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/icon_loading.png");
      background-size: 100%;
      animation-name: rote;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }

    .btn-loading-black {
      background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/icon_loading.png");
      background-size: 100%;
    }

    @keyframes rote {
      form {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
